import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PortfolioCategory { id: string; name: string; slug: string; sort_order: number; is_visible: boolean }
export interface PortfolioProject {
  id: string; title: string; summary: string | null; description: string | null; image_url: string | null;
  project_url: string | null; category_id: string | null; tags: string[] | null; is_featured: boolean; sort_order: number;
}

export function usePortfolio() {
  return useQuery({
    queryKey: ["portfolio-public"],
    staleTime: 2 * 60 * 1000,
    queryFn: async () => {
      const [cats, items] = await Promise.all([
        supabase.from("portfolio_categories").select("*").eq("is_visible", true).order("sort_order"),
        supabase.from("portfolio_items")
          .select("id,title,summary,description,image_url,project_url,category_id,tags,is_featured,sort_order")
          .eq("status", "published").is("deleted_at", null).order("sort_order"),
      ]);
      return {
        categories: (cats.data ?? []) as PortfolioCategory[],
        projects: (items.data ?? []) as PortfolioProject[],
      };
    },
  });
}
